import React from 'react';

import CommunityComments from 'components/CommunityComments/CommunityComments';
import { useAppContext } from 'hooks/useContext';
import { DiscussionTabContent } from './styles';

export default function FreecodeDiscussion({ testId, contestId }) {
  const { isDarkMode } = useAppContext();

  return (
    <DiscussionTabContent isDarkMode={isDarkMode}>
      <CommunityComments testId={testId} contestId={contestId} isDarkMode={isDarkMode} />
    </DiscussionTabContent>
  );
}
